import React from "react";
import { useSelector } from "react-redux";

const InputAutoComplete = ({
  selectedItem,
  items,
  label,
  value,
  onSelecItem,
  onItemClick,
  placeholder,
  register,
  disabled,
}) => {
  const darkMode = useSelector((state) => state.theme.darkMode);

  return (
    <div style={{ position: "relative" }}>
      <div className="input-group">
        {register ? (
          <input
            id="search"
            name="search"
            placeholder={placeholder}
            className="form-control searchField"
            style={{ borderRightWidth: 0 }}
            {...register}
            disabled={disabled}
          />
        ) : (
          <input
            id="search"
            name="search"
            placeholder={placeholder}
            className="form-control searchField"
            value={selectedItem}
            onChange={onSelecItem}
            style={{ borderRightWidth: 0 }}
            disabled={disabled}
          />
        )}

        <div className="input-group-append">
          <button
            disabled={disabled}
            className="btn btn-outline-dark btn-search"
            type="button"
            style={{
              borderWidth: 0.5,
              borderColor: "#ccc",
              borderLeftWidth: 0,
            }}
          >
            <i className="fa fa-search" />
          </button>
        </div>
      </div>
      {selectedItem && items.length > 0 && (
        <div
          style={{
            position: "absolute",
            top: 40,
            width: "100%",
            zIndex: 1,
            border: "1px solid #ccc",
            borderRadius: 5,
            padding: 5,
            background: darkMode ? "#777" : "#fff",
          }}
        >
          {items.map((item, i) => (
            <div
              key={i}
              className="d-flex justify-content-between mb-1"
              onClick={() => onItemClick && onItemClick(item[value])}
              style={{
                background: darkMode ? "#777" : "#fff",
                border: "1px solid #ccc",
                borderRadius: 5,
                width: "100%",
                padding: 5,
                cursor: "pointer",
              }}
            >
              <span>{item[label]}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InputAutoComplete;
